<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_center.delivery_receive') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" :emptyText="$t('globalTrans.noDataFound')" show-empty bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null">
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(sales_center)="data">
                                            <span>{{ getSalesCenterName(data.item.sales_center_id) }}</span>
                                        </template>
                                        <template v-slot:cell(delivery_date)="data">
                                            <span>{{ data.item.delivery_date | dateFormat }}</span>
                                        </template>
                                        <template v-slot:cell(delivery_id)="data">
                                          <span v-if="data.item.product_type === 1">{{ 'P - ' }} {{ data.item.delivery_id }}</span>
                                          <span v-else>{{ 'W - ' }} {{ data.item.delivery_id }}</span>
                                        </template>
                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-warning" v-if="data.item.status == 1">{{$t('globalTrans.partial')}}</span>
                                            <span class="badge badge-success" v-else>{{$t('sales_center.full')}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                          <span class="d-flex">
                                            <a href="javascript:" class="btn_table_action btn_green" @click="viewDetails(data.item)" v-b-modal.modal-1 :title="$t('globalTrans.details')"><i class="fas fa-eye"></i></a>
                                             <a href="javascript:" class="btn_table_action btn_blue" :title="$t('externalUser.production.receive_now')" v-b-modal.modal-receive size="sm" @click="receive(data.item)"><i class="ri-check-line m-0"></i></a>
                                          </span>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-modal id="modal-1" size="lg" :title="$t('sales_distribution_admin.deliver_now')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
                <DeliveryDetails :id="viewItem" />
        </b-modal>
        <b-modal id="modal-receive" size="lg" :title="$t('sales_center.delivery_receive')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <ReceiveModal :id="editItemId" :key="editItemId" />
        </b-modal>
    </b-container>
</template>
<script>
import DeliveryDetails from './deliveryDetails'
import ReceiveModal from './ReceiveModal'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { deliveryOrderReceiveListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import { mapGetters } from 'vuex'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    DeliveryDetails, ReceiveModal
  },
  data () {
    return {
      viewItem: '',
      billItem: '',
      chalanItem: '',
      passItem: '',
      rows: []
    }
  },
  computed: {
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    }),
    columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.delivery_id'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.delivery_date'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.sales_center'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.delivery_spot'), class: 'text-left' },
            // { label: this.$t('globalTrans.status'), class: 'text-center' },
            { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]
        let keys = []
        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'delivery_id' },
                { key: 'delivery_date' },
                { key: 'sales_center' },
                { key: 'delivery_location' },
                // { key: 'status' },
                { key: 'action' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'delivery_id' },
                { key: 'delivery_date' },
                { key: 'sales_center' },
                { key: 'delivery_location' },
                // { key: 'status' },
                { key: 'action' }
            ]
        }
      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    loadingState: function (newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    viewDetails (item) {
      this.viewItem = item.id
    },
    receive (item) {
      this.editItemId = item.id
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, deliveryOrderReceiveListApi, params).then(response => {
        if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
        }
      })
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
